import { Insurance } from "assets/icons/Insurance";
import { UserRole } from "constants/userRole";
import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import { userSelector } from "store/slices/user";
import styled from "styled-components";

import { CustomNavLink } from "./components/CustomNavLink/CustomNavLink";

const Container = styled.div`
  width: 82px;
  height: calc(100vh - 80px);

  top: var(--navbar-height);
  position: fixed;
  bottom: 0;

  background-color: var(--color-white);
  border-right: 1px solid var(--color-black-1);

  gap: 30px;

  display: flex;
  align-items: stretch;
  flex-direction: column;

  padding: var(--space-md) 5px var(--space-md) var(--space-sm);
`;

const Item = styled(NavLink)`
  all: unset;

  width: 100%;
  height: 44px;
  cursor: pointer;
  box-sizing: border-box;

  border-radius: 10px;
  padding: 0px;
  gap: 14px;

  display: flex;
  align-items: center;
  justify-content: flex-start;

  font-size: 12px;
  font-weight: 500;
  color: var(--color-black-9, #344054);

  i,
  svg {
    font-size: 18px;
    flex-shrink: 0;
    color: var(--color-black-9, #344054);
  }

  :hover {
    background: var(--primary-10);
  }

  &.active {
    background: var(--primary-10);
    color: var(--color-purple);

    i,
    svg {
      color: var(--color-purple);
    }
  }
`;

export function Sidebar(): JSX.Element {
  const { scope } = useSelector(userSelector);

  return (
    <Container className="flex justify-content-between">
      <div className="flex flex-column gap-3">
        {scope === UserRole.SUPER_ADMIN && (
          <>
            <Item data-testid="sidebar-reports-link" to="/reports">
              {/* <i className="pi pi-chart-line" /> */}
              <span>Reports</span>
            </Item>

            <CustomNavLink
              to="/hospitals"
              data-testid="sidebar-hospitals-link"
              matchLinks={["/hospitals/*", "/orders/*"]}
              style={{
                padding: "0",
                fontSize: "12px",
              }}
            >
              {/* <i className="pi pi-building" /> */}
              <span>Hospitals</span>
            </CustomNavLink>
            <Item to="/patients">
              {/* <i className="pi pi-id-card" /> */}
              <span>Patients</span>
            </Item>

            <Item to="/fee-schedule" data-testid="sidebar-fee-schedule-link">
              {/* <i className="pi pi-money-bill" /> */}
              <span>Fee Schedule</span>
            </Item>

            <Item to="/users">
              {/* <i className="pi pi-users" /> */}
              <span>Users</span>
            </Item>
            <Item to="/customize" data-test-id="sidebar-customize-link">
              {/* <i className="pi pi-cog" /> */}
              <span>Customize</span>
            </Item>
            <Item to="/payer-rules" data-test-id="sidebar-payer-rules-link">
              {/* <Insurance width={16} height={16} /> */}
              <span>Payer Rules</span>
            </Item>
            <Item
              to="/revenue-dashboard"
              data-test-id="sidebar-revenue-dashboard-link"
            >
              {/* <i className="pi pi-chart-bar" /> */}
              <span>Revenue</span>
            </Item>
            <Item to="/chatbot" data-test-id="sidebar-chatbot-link">
              {/* <i className="pi pi-android" /> */}
              <span>Chatbot</span>
            </Item>
            <Item to="/hst-sync" data-test-id="sidebar-hst-sync-link">
              {/* <i className="pi pi-sync" /> */}
              <span>HSC sync</span>
            </Item>
          </>
        )}
      </div>

      <img
        src="/logo_new.svg"
        alt="Clear Health Logo"
        style={{ cursor: "pointer", width: "100%" }}
      />
    </Container>
  );
}
